module.exports = __webpack_public_path__ + "static/media/test_audio.7a812319.gif";